import React, { forwardRef } from 'react';
import './appearanceBoundary.css';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  pending: boolean;
  error?: string;
  onRetry?: () => void;
  retryLabel?: string;
};

/** Keep inputs mounted, but never paint a table before its owning appearance is ready. */
const AppearanceBoundary = forwardRef<HTMLDivElement, Props>(
  function AppearanceBoundary(
    {
      pending,
      error,
      onRetry,
      retryLabel = 'Retry appearance',
      children,
      ...props
    },
    ref
  ) {
    return (
      <div
        {...props}
        ref={ref}
        data-appearance-pending={pending || error ? 'true' : undefined}
        aria-busy={(pending && !error) || undefined}
      >
        {error ? (
          <div className="document-theme-load-error" role="alert">
            {error}
            {onRetry && (
              <button type="button" onClick={onRetry}>
                {retryLabel}
              </button>
            )}
          </div>
        ) : (
          pending && (
            <div className="document-theme-loading" role="status">
              Loading company appearance…
            </div>
          )
        )}
        {children}
      </div>
    );
  }
);
export default AppearanceBoundary;
